import ForgotPassAPI from '../../APIs/LoginAPI/UserDataAPI'
import router from '../../../router/index'

export const forgotPass = {
    state: {
        forgotPassUserInfo: '',
        isRecoveryPassLinkSent: '',
        recoveryEmail: '',
        forgottenMembn: '',
        passwordChanged: '',
        inactiveStat: '',
        errorPrompt: '',
        userExists: ''
    },
    actions: {
        // User enters member code and display account if ACTIVE
        forgotPassUserInfo({ commit }, userMembn) {
            ForgotPassAPI.forgotPassUserInfo(userMembn)
                .then(res => {
                    commit('USER_EXISTS', '')
                    if (res.status == 404) {
                        // User was not found in the db
                        commit('USER_EXISTS', res.data)
                    } else if (res.data[0].STATUS == 'ACTIVE') {
                        commit('FORGOT_PASS_INFO', res.data)
                        // tl.to(".forgotPassFormWrapper", 0.3, {
                        //   display: "none",
                        // });
                        // tl.to(".displayForgotAccnt", 0.3, {
                        //   display: "flex",
                        // });
                        userMembn.toggle = false
                    } else {
                        commit('INACTIVE_STATUS', res.data[0].STATUS)
                        commit('FORGOT_PASS_INFO', null)
                        userMembn.toggle = true
                    }
                })
                .catch(() => {
                    // console.log(error);
                })
        },

        // Will send a recovery link to users provided email addres to reset password
        async recoveryLink({ commit }, userCred) {
            // If user want to resend recovery link for password
            // If reset is true,
            commit('ERROR_PROMPT', '')
            // console.log("EXECUTED 1");
            // console.log(userCred.RESET);
            if (userCred.RESET) {
                // console.log("EXECUTED 2");
                await ForgotPassAPI.forgotPassRecoveryLink(userCred)
                    .then(res => {
                        if (res.data.MAIL_SENT) {
                            commit('IS_RECOVERY_PASS_LINK_SENT', res.data.MAIL_SENT)
                            commit('RECOVERY_EMAIL', res.data.EMAIL)
                        } else {
                            commit('IS_RECOVERY_PASS_LINK_SENT', res.data.MAIL_SENT)
                            commit('ERROR_PROMPT', res.data.err)
                        }
                    })
                    .catch(error => {
                        // console.log(error);
                        commit('ERROR_PROMPT', error.response.data.err)
                    })
            } else {
                // console.log("EXECUTED 3");
                await ForgotPassAPI.forgotPassRecoveryLink(userCred)
                    .then(res => {
                        if (res.data.MAIL_SENT) {
                            commit('IS_RECOVERY_PASS_LINK_SENT', res.data.MAIL_SENT)
                            commit('RECOVERY_EMAIL', res.data.EMAIL)
                            router.push(`/resetPassNotif?membn=${res.data.MEMBN}`)
                        } else {
                            commit('IS_RECOVERY_PASS_LINK_SENT', res.data.MAIL_SENT)
                            commit('ERROR_PROMPT', res.data.err)
                        }
                    })
                    .catch(error => {
                        commit('ERROR_PROMPT', error.response.data.err)
                    })
            }
        },

        // Verifies the link if
        verifyForgotPassRecoveryLink({ commit }, token) {
            ForgotPassAPI.verifyForgotPassRecoveryLink(token).then(res => {
                if (res.data.IS_RESET_TOKEN) {
                    commit('FORGOTTEN_MEMBN', res.data.MEMBN)
                } else {
                    router.push(`/recoveryLinkExpired?exp=${res.data.exp}`)
                }
            })
        },

        // Resets password
        // If password changed, will redirect to login.
        resetPassword({ commit }, passCredntials) {
            if (passCredntials.PASS === passCredntials.RETYPED_PASS) {
                ForgotPassAPI.resetPassword(passCredntials).then(res => {
                    let counter = 6
                    commit('PASSWORD_CHANGED', res.data.msg)
                    const updateMsg = setInterval(() => {
                        if (counter <= 5)
                            commit('PASSWORD_CHANGED', `Redirecting to login page... (${counter})`)
                        counter = counter - 1
                        if (counter === 0) clearInterval(updateMsg)
                    }, 1000)
                    setTimeout(() => {
                        router.push('/')
                    }, 7000)
                })
            } else {
                // console.log("PASSWORD MISMATCH");
            }
        }
    },
    mutations: {
        FORGOT_PASS_INFO(state, forgotPassUserInfo) {
            state.forgotPassUserInfo = forgotPassUserInfo
        },
        IS_RECOVERY_PASS_LINK_SENT(state, isRecoveryPassLinkSent) {
            state.isRecoveryPassLinkSent = isRecoveryPassLinkSent
        },
        RECOVERY_EMAIL(state, recoveryEmail) {
            state.recoveryEmail = recoveryEmail
        },
        FORGOTTEN_MEMBN(state, forgottenMembn) {
            state.forgottenMembn = forgottenMembn
        },
        PASSWORD_CHANGED(state, passwordChanged) {
            state.passwordChanged = passwordChanged
        },
        INACTIVE_STATUS(state, inactiveStat) {
            state.inactiveStat = inactiveStat
        },
        ERROR_PROMPT(state, errorPrompt) {
            state.errorPrompt = errorPrompt
        },
        USER_EXISTS(state, userExists) {
            state.userExists = userExists
        }
    },
    getters: {
        getForgotPassUserInfo(state) {
            return state.forgotPassUserInfo
        },
        isRecoveryPassLinkSent(state) {
            return state.isRecoveryPassLinkSent
        },
        getRecoveryEmail(state) {
            return state.recoveryEmail
        },
        forgottenMembn(state) {
            return state.forgottenMembn
        },
        passwordChanged(state) {
            return state.passwordChanged
        },
        getForgottenAccountStat(state) {
            return state.inactiveStat
        },
        getErrorPrompt(state) {
            return state.errorPrompt
        },
        getUserExists(state) {
            return state.userExists
        }
    }
}
